import { useClient } from '~/stores/client'

export default defineNuxtRouteMiddleware((to) => {
  const companyId = String(to.params.id ?? '')
  const client = useClient()

  if (client.isAdmin || client.companies.some(company => company.id === companyId)) {
    return
  }

  return abortNavigation(createError({ statusCode: 403, statusMessage: 'Нет доступа к компании' }))
})
